import { render, staticRenderFns } from "./uploaddownchi.vue?vue&type=template&id=057c8b56"
import script from "./uploaddownchi.vue?vue&type=script&lang=js"
export * from "./uploaddownchi.vue?vue&type=script&lang=js"
import style0 from "./uploaddownchi.vue?vue&type=style&index=0&id=057c8b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports